import React, { Component } from 'react';
import { useDocumentMeta } from '../hooks/useDocumentMeta';
import { PageHero } from '../components/PageHero';
import { CheckCircle2, MapPin } from 'lucide-react';
import { Link } from 'react-router-dom';
export function ReloadingSupplies() {
  useDocumentMeta('Reloading Supplies in Lake Benton, Minnesota | Kjergaard Sports', 'Find bullets, powders, primers, presses, dies, scales, and reloading tools at Kjergaard Sports in Lake Benton, Minnesota.');
  const categories = ['Bullets', 'Powder', 'Primers', 'Shot', 'Wads', 'Hulls', 'Presses', 'Dies', 'Scales', 'Reloading tools'];
  return <div data-id="element-484">
      <PageHero title="Reloading Supplies in Lake Benton, Minnesota" image="https://cdn.magicpatterns.com/uploads/8918DCMwwSgbp8VrUA2ZyG/reloading-supplies.jpg" alt="Reloading supplies at Kjergaard Sports" data-id="element-485" />

      <section className="py-20 bg-brand-offwhite" data-id="element-486">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-487">
          <div className="grid lg:grid-cols-2 gap-16 items-center" data-id="element-488">
            <div className="order-2 lg:order-1" data-id="element-489">
              <img src="https://cdn.magicpatterns.com/uploads/8918DCMwwSgbp8VrUA2ZyG/reloading-supplies.jpg" alt="Reloading supplies selection at Kjergaard Sports" className="w-full h-auto rounded-sm shadow-lg object-cover" data-id="element-490" />
            </div>

            <div className="order-1 lg:order-2" data-id="element-491">
              <h2 className="text-3xl md:text-4xl font-serif text-brand-charcoal mb-6" data-id="element-492">
                Components & Tools for the Bench
              </h2>
              <p className="text-lg text-brand-charcoal/80 mb-6 leading-relaxed" data-id="element-493">
                For customers who demand precision or simply enjoy the craft of
                building their own ammunition, Kjergaard Sports offers a
                dedicated selection of reloading supplies and equipment.
              </p>

              <div className="bg-brand-bone p-8 rounded-sm border border-brand-cream mb-8" data-id="element-494">
                <h3 className="font-serif text-xl mb-4" data-id="element-495">
                  We Carry Supplies For:
                </h3>
                <ul className="grid sm:grid-cols-2 gap-3" data-id="element-496">
                  {categories.map((item, index) => <li key={index} className="flex items-start" data-id="element-497">
                      <CheckCircle2 className="w-5 h-5 text-brand-hunter mr-2 flex-shrink-0 mt-0.5" data-id="element-498" />
                      <span className="text-brand-charcoal/90" data-id="element-499">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-brand-cream border-l-4 border-brand-sage p-6 mb-8" data-id="element-500">
                <p className="text-brand-charcoal/90 text-sm leading-relaxed" data-id="element-501">
                  <strong data-id="element-502">Safety Note:</strong> Reloading requires strict
                  adherence to published load data from powder and bullet
                  manufacturers. Kjergaard Sports provides the components and
                  tools, but we do not provide load data, powder charges, or
                  technical reloading recipes. Always consult current, published
                  reloading manuals for safe practices.
                </p>
              </div>

              <Link to="/contact" className="inline-flex bg-brand-hunter hover:bg-brand-wood text-brand-offwhite px-8 py-4 rounded-sm font-medium transition-colors items-center" data-id="element-503">
                <MapPin className="w-5 h-5 mr-2" data-id="element-504" />
                Visit the Store for Supplies
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>;
}